<a [routerLink]="routerLink" [fragment]="fragment" class="back-button">↩ {{ label }}</a>
